import { useFeatureIsOn } from '@monofront/business/contexts/growthbook';
import { ABTEST_DELIVERY_BAR } from '@monofront/business/constants';
import { DeliveryBarCTA } from './DeliveryBarCTA';

export const DeliveryBarCTAABTest = (props: { hideIfEmpty?: boolean }) => {
  const isDeliveryBarABTestEnabled = useFeatureIsOn(ABTEST_DELIVERY_BAR);

  if (!isDeliveryBarABTestEnabled) {
    return null;
  }

  return <DeliveryBarCTA {...props} />;
};
